export default __webpack_public_path__ + "static/media/CracklingCoffee-Logo(Yellow)-01.382989af.svg";